import SettingsPage from "../components/SettingsPane/SettingsPage";
import { showToast } from "../components/Toasts";
import { itx } from "../translationItx/itx";

export default function SettingPageSystem(props: { handler: string }) {
  return (
    <SettingsPage
      handler="/settings/system" // no itx
    >
      <button
        className="button"
        onClick={() => {
          //
          showToast({ text: itx("SettingsScreen.hasToBeImplemented", "has to be implemented") });
        }}
      >
        {itx("SettingsScreen.deleteProductDataFromLocalStorage", "delete productdata from local Storage")}
      </button>
      <button
        className="button"
        onClick={() => {
          //
          showToast({ text: itx("SettingsScreen.hasToBeImplemented", "has to be implemented") });
        }}
      >
        {itx("SettingsScreen.deleteProjectsFromLocalStorage", "delete projects from local storage")}
      </button>
    </SettingsPage>
  );
}
